import { useContext, useMemo } from 'react';

import { ISelectOption, ITabOption } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { EType, HostGroupsData } from '../interface';

export const useTypeOptions = (): Array<ITabOption<EType>> => {
  const { t } = useContext(LocalizationContext);
  const TYPE_OPTIONS: Array<ITabOption<EType>> = [
    { value: EType.APPLICATION, title: t('applicationsReport.tab.process') },
    { value: EType.WINDOW, title: t('applicationsReport.tab.window') },
    { value: EType.CLICK, title: t('applicationsReport.tab.click') },
  ];
  return TYPE_OPTIONS;
};

export const useHostOptions = (
  hostGroupsData: HostGroupsData | undefined,
  selectedHostGroupId: number | null,
  selectedHostId: number | null
): {
  hostOptions: Array<ISelectOption<string | number>>;
  hostGroupOptions: Array<ISelectOption<string | number>>;
} => {
  return useMemo(() => {
    const hostGroupOptions: Array<ISelectOption<string | number>> =
      selectedHostId && hostGroupsData
        ? hostGroupsData.hostGroupsOverview
            .filter((group) =>
              hostGroupsData.hostsOverview.some(
                (host) =>
                  host.id === selectedHostId && host.group_id === group.id
              )
            )
            .map(({ id, title }) => ({
              value: id,
              title,
            }))
        : hostGroupsData?.hostGroupsOverview.map(({ id, title }) => ({
            value: id,
            title,
          })) ?? [];

    const hostOptions: Array<ISelectOption<string | number>> =
      hostGroupsData?.hostsOverview
        .filter((host) =>
          selectedHostGroupId ? host.group_id === selectedHostGroupId : true
        )
        .map(({ alias, id }) => ({
          value: id,
          title: alias,
        })) ?? [];

    return { hostOptions, hostGroupOptions };
  }, [hostGroupsData, selectedHostGroupId, selectedHostId]);
};
